export default "__VITE_ASSET__De50smX9__"